module.exports = __webpack_public_path__ + "img/farm-shots.278a2315.png";